import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  
  message = "Loading...";
  progress = {
    totalRecords: 0,
    processedRecords: 0,
    batchStatus: 'success',
    retryCount: 0,
    unit: 'records'
  };
  requireAcknowledgement = false;
  finalMessage = '';
  finalRecordCount: string | null = null;
  finalProcessingTime: string | null = null;
  finalRetrySummary = '';
  verboseMode = false;
  statusLines: string[] = [];
  networkOnline = true;
  currentAction = '';

  constructor(private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    Office.context.ui.addHandlerAsync(Office.EventType.DialogParentMessageReceived, (arg: any) => {
      let payload: any = arg?.message;
      try {
        payload = JSON.parse(arg?.message);
      } catch {
        payload = arg?.message;
      }

      if (typeof payload === 'string') {
        this.message = !['', undefined, null].includes(payload) ? payload : this.message;
      }

      if (payload && typeof payload === 'object') {
        if (typeof payload.message === 'string' && payload.message.trim() !== '') {
          this.message = payload.message;
        } else if (payload.currentBatch !== undefined && payload.totalBatch !== undefined) {
          this.message = `Loading batch ${payload.currentBatch} of ${payload.totalBatch}`;
        }

        if (payload.progress && typeof payload.progress === 'object') {
          this.progress = {
            totalRecords: payload.progress.totalRecords || 0,
            processedRecords: payload.progress.processedRecords || 0,
            batchStatus: payload.progress.batchStatus || 'success',
            retryCount: payload.progress.retryCount || 0,
            unit: payload.progress.unit || 'records'
          };
        }

        this.requireAcknowledgement = !!payload.requireAcknowledgement;
        this.finalMessage = payload.finalMessage || '';
        this.finalRecordCount = payload.finalRecordCount ?? null;
        this.finalProcessingTime = payload.finalProcessingTime ?? null;
        this.finalRetrySummary = payload.finalRetrySummary || '';
        this.verboseMode = !!payload.verboseMode;
        this.statusLines = Array.isArray(payload.statusLines)
          ? payload.statusLines.filter((item: any) => typeof item === 'string' && item.trim() !== '')
          : [];
        if (payload.networkOnline !== undefined) {
          this.networkOnline = !!payload.networkOnline;
        }
        if (typeof payload.action === 'string') {
          this.currentAction = payload.action;
        }
      }

      this.cdr.detectChanges();
    }, () => Office.context.ui.messageParent('start'));
  }

  get progressPercent(): number {
    if (!this.progress.totalRecords) {
      return 0;
    }
    return Math.min(100, Math.round((this.progress.processedRecords / this.progress.totalRecords) * 100));
  }

  get isSuccessfulBatch(): boolean {
    return (this.progress.batchStatus || '').toLowerCase() !== 'failed';
  }

  get progressStatusClass(): string {
    return this.isSuccessfulBatch ? 'status-success' : 'status-failed';
  }

  get progressUnit(): string {
    return this.progress.unit || 'records';
  }

  get showRefreshResultsNote(): boolean {
    return this.currentAction === 'publish';
  }

  acknowledgeFinalStatus() {
    Office.context.ui.messageParent('acknowledge');
  }

}
